/* Atipiná PDP — Fix do botão AVISE-ME em produto totalmente esgotado
   Sem esse fix, era preciso clicar num tamanho (esgotado) pra liberar o modal.
   Agora detecta produto 100%% sold-out no load e força o botão em modo notify.
   2026-05-22
   2026-06-02: texto do CTA padronizado pra "AVISE-ME QUANDO CHEGAR" (bate com a cart-bar).
   Normaliza qualquer "AVISE-ME" solto (Liquid inicial / setCtaMode do main-product). */
(function(){
  'use strict';

  var NOTIFY_TEXT = 'AVISE-ME QUANDO CHEGAR';

  /* Reescreve CTA cujo texto seja exatamente "AVISE-ME" pro texto completo. */
  function normalizeCtaText(root){
    (root || document).querySelectorAll('product-component.pdp-live [data-add-to-cart] .btn__text').forEach(function(el){
      var t = (el.textContent || '').trim().toUpperCase();
      if (t === 'AVISE-ME') el.textContent = NOTIFY_TEXT;
    });
  }

  function isFullySoldout(sec, cta){
    var radios = sec.querySelectorAll('.pdp-live__variant--size input[type="radio"]');
    if (radios.length === 0){
      return cta && cta.getAttribute('data-cta-mode') === 'notify';
    }
    return Array.prototype.every.call(radios, function(r){
      return r.getAttribute('data-soldout') === 'true';
    });
  }

  function forceNotifyMode(sec){
    var cta = sec.querySelector('[data-add-to-cart]');
    if (!cta || cta.__soldoutFixed) return;

    if (!isFullySoldout(sec, cta)) return;

    cta.__soldoutFixed = true;

    var ctaText = cta.querySelector('.btn__text');
    cta.setAttribute('data-cta-mode', 'notify');
    cta.classList.add('pdp-live__cta--notify');
    cta.removeAttribute('disabled');
    if (ctaText) ctaText.textContent = NOTIFY_TEXT;

    var radios = sec.querySelectorAll('.pdp-live__variant--size input[type="radio"]');
    if (radios.length > 0 && !sec.querySelector('.pdp-live__variant--size input[type="radio"]:checked')){
      radios[0].checked = true;
    }

    var sectionId = sec.getAttribute('data-section-id');
    var modal = sectionId ? document.getElementById('PDPLive-' + sectionId + '-soldout-modal') : null;

    cta.addEventListener('click', function(e){
      if (cta.getAttribute('data-cta-mode') !== 'notify') return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      if (!modal) return;
      if (typeof modal.showModal === 'function'){
        try { modal.showModal(); }
        catch(err){ modal.setAttribute('open', ''); }
      } else {
        modal.setAttribute('open', '');
      }
      document.body.style.overflow = 'hidden';
    }, true);

    var form = sec.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(e){
        if (cta.getAttribute('data-cta-mode') !== 'notify') return;
        e.preventDefault();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        if (modal){
          if (typeof modal.showModal === 'function'){
            try { modal.showModal(); }
            catch(err){ modal.setAttribute('open', ''); }
          } else {
            modal.setAttribute('open', '');
          }
          document.body.style.overflow = 'hidden';
        }
      }, true);
    }
  }

  function run(){
    document.querySelectorAll('product-component.pdp-live').forEach(function(sec){
      forceNotifyMode(sec);
      normalizeCtaText(sec);
      // observa o CTA: se algum outro script setar "AVISE-ME", reescreve
      if (!sec.__ctaTextObs){
        var cta = sec.querySelector('[data-add-to-cart]');
        if (cta && 'MutationObserver' in window){
          sec.__ctaTextObs = true;
          new MutationObserver(function(){ normalizeCtaText(sec); })
            .observe(cta, { childList: true, subtree: true, characterData: true });
        }
      }
    });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 400);
  setTimeout(run, 1200);
})();
